import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { facebookOAuthAPI } from '../../components/LoginWithFacebookButton/ApiService';
import { useCookies } from 'react-cookie';

export default function FacebookOAuth() {
    const location = useLocation();
    const navigate = useNavigate();

    const [cookies, setCookie] = useCookies(["access_token"]);

    const params = new URLSearchParams(location.search);

    useEffect(() => {
        facebookOAuthAPI(params.get('state') ?? '', params.get('code') ?? '', params.get('error') ?? '', params.get('error_description') ?? '').then(resp => {
            if (resp.status === 200 && resp.data && resp.data.isSuccess) {
                let expires = new Date();
                expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000);

                setCookie("access_token", resp.data.token, {
                    path: "/",
                    expires: expires,
                    maxAge: 7 * 24 * 60 * 60,
                    secure: true,
                    sameSite: "strict",
                })

                navigate("/home")
            }
        }).catch(e => console.error)
    }, [])
    return (
        <></>
    )
}